<h2 class="popup-heading" mat-dialog-title>{{ title }}</h2>
<div class="content">
    <form [formGroup]="billingForm" class="billing-form">
        <mat-form-field [hidden]="true" appearance="outline" class="full-width">
            <input matInput formControlName="user_uuid" placeholder="Enter Email" [ngModel]="EditCustomer.UUID">
        </mat-form-field>
        <div class="half-width">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="first_name" placeholder="Enter first name"
                    [ngModel]="EditCustomer.first_name" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="last_name" placeholder="Enter last name"
                    [ngModel]="EditCustomer.last_name" />
            </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="Enter Email" [ngModel]="EditCustomer.email" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="address_1" placeholder="Enter address"
                [ngModel]="EditCustomer.address_1" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Address Line 2</mat-label>
            <input matInput formControlName="address_2" placeholder="Enter address (optional)"
                [ngModel]="EditCustomer.address_2" />
        </mat-form-field>

        <div class="half-width">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" placeholder="Enter city" [ngModel]="EditCustomer.city" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>State</mat-label>
                <input matInput formControlName="state" placeholder="Enter state" [ngModel]="EditCustomer.state" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Zip / Postal Code</mat-label>
                <input matInput formControlName="zip_code" placeholder="Enter zip code"
                    [ngModel]="EditCustomer.zip_code" />
            </mat-form-field>
        </div>
    </form>
    <mat-dialog-actions class="custom-dialog-actions" align="end">
        <button class="cancel-popup" mat-stroked-button mat-dialog-close (click)="close()">Cancel</button>
        <button class="popup-save" mat-flat-button
            [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" type="submit"
            (click)="save()" [disabled]="processing">
            <mat-icon *ngIf="processing">
                <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
            </mat-icon>
            Save
        </button>
    </mat-dialog-actions>
    <h2 class="popup-heading mat-dialog-title" *ngIf="EditCustomer.payment_methods.length > 0">Payment Methods</h2>
    <div class="payment-methods-row customer-payment-methods">
        <div class="payment-methods-item" *ngFor="let method of EditCustomer.payment_methods">
            <mat-card class="payment-card selected">
                <div class="card-header mat-elevation-z0">
                    <h4 class="card-title" style="text-transform: capitalize;">{{method.details.card.brand}}</h4>
                     <button class="save"mat-flat-button (click)="cardDefault(method)"[ngStyle]="{'color': 'var(--primary-color)','text-decoration': method.default_method === 1 ? 'underline' : 'none','text-decoration-color': 'var(--primary-color)','text-decoration-thickness': '2px','text-underline-offset': '4px'}"type="submit"[disabled]="processing || method.default_method === 1">
                      <mat-icon *ngIf="processing">
                        <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
                      </mat-icon>
                      {{ method.default_method === 1 ? 'Primary' : 'Set Primary' }}
                    </button>  
                </div>
                <div class="card-content">
                    <img class="card-logo"
                        [src]="getCardIcon(method.details.card.brand)"
                        alt="{{ method.details.card.brand }}" />
                    <span class="card-number">•••• •••• •••• {{ method.details.card.last4 }}</span>
                </div>
                <div class="card-footer payment-footer">
                    <span>EXP {{ method.details.card.exp_month }}/{{ method.details.card.exp_year }}</span>
                    <button mat-button color="warn" (click)="removeCard(method)">Remove</button>
                </div>
            </mat-card>
        </div>
    </div>
</div>